import api from '../..'
import { ICourseModel } from '../../../models/course.model'
import { ObjectToFormDataWithFiles, decamelizeThatDontBreaksFile } from '../../../helpers/converters.helper'

const editCourse = (course: ICourseModel, courseId: string) => {
  const decamelizeData = decamelizeThatDontBreaksFile(course)
  const formData = ObjectToFormDataWithFiles(decamelizeData, 'course')
  return api.patch(`administration/courses/${courseId}`, formData, {
    headers: { 'content-type': 'multipart/form-data' },
  })
}

export default editCourse
